import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

(function () {

  const loadImage = function(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
      img.src = src;
    });
  };

  const galleries = document.querySelectorAll('.wp-block-image a[href$=".jpg"], .wp-block-image a[href$=".jpeg"], .wp-block-image a[href$=".png"], .wp-block-image a[href$=".gif"]');
  if (galleries.length > 0) {
    const gallery = galleries[0].parentNode;

    // aタグにdata-pswp-widthとdata-pswp-height属性を付ける
    galleries.forEach((el, index, array) => {
      el.classList.add('is-loading', 'modal-item'); // ローディング状態を表示

      loadImage(el.href).then(img => {
        el.setAttribute('data-pswp-width', img.naturalWidth);
        el.setAttribute('data-pswp-height', img.naturalHeight);
        el.classList.remove('is-loading'); // ローディング状態を解除
      });
      const figure = el.closest('figure');
      // PhotoSwipeを適用
      const lightbox = new PhotoSwipeLightbox({
        gallery: figure, //リストを囲む要素を指定
        children: 'a', //ポップアップさせる要素を指定
        pswpModule: PhotoSwipe // PhotoSwipeのCoreモジュールをここに指定
      });

      lightbox.init();

    });

  }

})();
